import callAPI from "config/callAPI";

import React from "react";

import LandingHeader from "pages/landing/includes/LandingHeader";
import LandingFooter from "pages/landing/includes/LandingFooter";

const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/register';
const UTILITIES_ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/site_utilities';

class Home extends React.Component {

    constructor(){
        super();
        this.state = {
            sdata: [],
            ralertColor: '',
            rrstatus: '',
            rrmessage: '',
            rrdata: [],
            salertColor: '',
            rsstatus: '',
            rsmessage: '',
            rsdata: []
        } 

        this.getStats();
    }

    async getStats() {
        var data = {action: 'get_stats'};

        // eslint-disable-next-line
        const {rstatus, rmessage, rdata } = await callAPI(UTILITIES_ENDPOINT, data); 
        this.setState({
            sdata: rdata
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        let data = Object.fromEntries(new FormData(e.target));

        const {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data); 
        this.setState({
            rrstatus: rstatus,
            rrmessage: rmessage,
            rrdata: rdata
        });
        
        if (rstatus === true){ this.setState({ralertColor: 'green'}); } 
        else if (rstatus === false) { this.setState({ralertColor: 'red'}); }
    }

    handleSubscribeSubmit = async (e) => {
        e.preventDefault();

        let data = Object.fromEntries(new FormData(e.target));
        data.action = 'subscribe';

        const {rstatus, rmessage, rdata } = await callAPI(UTILITIES_ENDPOINT, data); 
        this.setState({
            rsstatus: rstatus,
            rsmessage: rmessage,
            rsdata: rdata
        });
        
        if (rstatus === true){ this.setState({salertColor: 'green'}); } 
        else if (rstatus === false) { this.setState({salertColor: 'red'}); }
    }

    render() {
        return (
            <>
                <LandingHeader />
                
                <div className="registration-area default-padding bg-dark text-light">
                    <div className="fixed-bg bg-cover" style={{"backgroundImage": "url(assets/edocom/img/banner/1.jpg)"}}></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-7 countdown">
                                <h2>Register today</h2>
                                <h4>Get part of the platform and create shortened URLs!</h4>
                                <p>
                                    Start using our platform today and be a part of this and create shortened, easily shareable URLs. Alongside this also track URL statistics to better analyze and plan your marketing goals accordingly. Start using now without any delay and get ahead of others in your marketing goals. See you soon!  
                                </p>
                                <ul>
                                    <li>Shorten URL</li>
                                    <li>Analyze URL activivity</li>
                                    <li>Alwas Free</li>
                                    <li>Plan progressively</li>
                                </ul>
                                <div className="counter-class">
                                    <div className="row">
                                        <div className="item-list">
                                            <div className="counter-item">
                                                <div className="item">
                                                    <span className="counter-days">00</span> Days
                                                </div>
                                            </div>
                                            <div className="counter-item">
                                                <div className="item">
                                                    <span className="counter-hours">00</span> Hours
                                                </div>
                                            </div>
                                            <div className="counter-item">
                                                <div className="item">
                                                    <span className="counter-minutes">00</span> Minutes
                                                </div>
                                            </div>
                                            <div className="counter-item">
                                                <div className="item">
                                                    <span className="counter-seconds">00</span> Seconds
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-5 reg-form">
                                <form onSubmit={event => this.handleSubmit(event)} method="post">
                                    <h5>Free</h5>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <input className="form-control" placeholder="Email" name="email" type="text"/>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <input className="form-control" placeholder="Password" name="password" type="password"/>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <label className="inline-block">
                                                <input type="checkbox" name="accept" style={{"minHeight": 0, "margin": "0 5px 0 0"}} />
                                                <span>
                                                    I accept the <a style={{"color": "blue"}} target="_blank" href="/terms">terms and conditions</a>
                                                </span>
                                            </label>
                                        </div>
                                        <div className="col-md-12">
                                            <button type="submit">
                                                Rigister Now
                                            </button>
                                        </div>
                                        <div className="col-md-12">
                                            { this.state.rrstatus !== '' ?
                        
                                                <p style={{ color: this.state.ralertColor, paddingTop: "10px"}}>
                                                    {this.state.rrmessage}
                                                </p>
                                
                                                : ""
                                            }
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="category-area default-padding">
                    <div className="container">
                        <div className="row">
                            <div className="site-heading text-center">
                                <div className="col-md-8 col-md-offset-2">
                                    <h2>Our Features</h2>
                                    <p>
                                        UShort is equipped with many exquisite features. First of all you can shorten your long URLs into attractive and shareale short URLs. Also you can track the link clicks and performances of the URLs you have shared. This hugely impact your planning on how to share your URLs and your marketing goals. 
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="category-items">
                            <div className="row">
                                <div className="col-md-4 col-sm-4 equal-height">
                                    <div className="item mariner">
                                        <a href="/signup">
                                            <div className="item-box">
                                                <div className="icon">
                                                    <i className="flaticon-worldwide"></i>
                                                </div>
                                                <div className="info">
                                                    <h5>Shorten URL</h5>
                                                    <p>
                                                        Shorten your URLs for easy sharing.
                                                    </p>
                                                    <span><i className="ti-arrow-right"></i></span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-4 equal-height">
                                    <div className="item java">
                                        <a href="/signup">
                                            <div className="item-box">
                                                <div className="icon">
                                                    <i className="flaticon-film"></i>
                                                </div>
                                                <div className="info">
                                                    <h5>Track Visitors</h5>
                                                    <p>
                                                        Track your link clicks and plan accordingly.
                                                    </p>
                                                    <span><i className="ti-arrow-right"></i></span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-4 equal-height">
                                    <div className="item malachite">
                                        <a href="/signup">
                                            <div className="item-box">
                                                <div className="icon">
                                                    <i className="flaticon-play-button"></i>
                                                </div>
                                                <div className="info">
                                                    <h5>Analyze Link Clicks</h5>
                                                    <p>
                                                        Analyze your visitors from geo data and plan.
                                                    </p>
                                                    <span><i className="ti-arrow-right"></i></span>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="fun-factor-area default-padding text-center bg-fixed shadow dark-hard" style={{"backgroundImage": "url(assets/edocom/img/banner/3.jpg)"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-3 col-sm-6 item">
                                <div className="fun-fact">
                                    <div className="icon">
                                        <i className="fas fa-users"></i>
                                    </div>
                                    <div className="info">
                                        <span className="timer" data-to={this.state.sdata.total_users} data-speed="5000">{this.state.sdata.total_users}</span>
                                        <span className="medium">Users</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 item">
                                <div className="fun-fact">
                                    <div className="icon">
                                        <i className="fas fa-link"></i>
                                    </div>
                                    <div className="info">
                                        <span className="timer" data-to={this.state.sdata.total_links_created} data-speed="5000">{this.state.sdata.total_links_created}</span>
                                        <span className="medium">Links Created</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 item">
                                <div className="fun-fact">
                                    <div className="icon">
                                        <i className="fas fa-link"></i>
                                    </div>
                                    <div className="info">
                                        <span className="timer" data-to={this.state.sdata.total_links_clicked} data-speed="5000">{this.state.sdata.total_links_clicked}</span>
                                        <span className="medium">Link Clicked</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3 col-sm-6 item">
                                <div className="fun-fact">
                                    <div className="icon">
                                        <i className="fas fa-users"></i>
                                    </div>
                                    <div className="info">
                                        <span className="timer" data-to={this.state.sdata.total_subscribers} data-speed="5000">{this.state.sdata.total_subscribers}</span>
                                        <span className="medium">Subscribers</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="newsletter-area">
                    <div className="container">
                        <div className="subscribe-items shadow theme-hard default-padding bg-cover" style={{"backgroundImage": "url(assets/edocom/img/banner/2.jpg)"}}>
                            <div className="row">
                                <div className="col-md-7 left-info">
                                    <div className="info-box">
                                        <div className="icon">
                                            <i className="flaticon-email"></i>
                                        </div>
                                        <div className="info">
                                            <h3>Subscribe to our newsletter</h3>
                                            <p>
                                                Subscribe to our newsletter to stay updated whats latest happening about us and keep in pace with the new things we are keeping on providing.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-5">
                                    <form onSubmit={event => this.handleSubscribeSubmit(event)} method="post">
                                        <div className="input-group">
                                            <input type="email" placeholder="Enter your e-mail here" className="form-control" name="email" />
                                            <button type="submit">
                                                Subscribe <i className="fa fa-paper-plane"></i>
                                            </button>  
                                        </div>
                                    </form>
                                    { this.state.rsstatus !== '' ?
                
                                        <p style={{ color: this.state.salertColor, paddingTop: "10px"}}>
                                            {this.state.rsmessage}
                                        </p>
                        
                                        : ""
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <LandingFooter />
            </>
        );
    }
}

export default Home;
